import { IZone } from "@nju/data-access-portal-dashboard";
import { IOfferType } from "../types";

interface IResolveOfferTypeProps {
  roamingZone: IZone["name"];
  promoRoamingZone: IZone["name"] | undefined;
}

export function resolveOfferType({
  roamingZone,
  promoRoamingZone,
}: IResolveOfferTypeProps): IOfferType | undefined {
  if (roamingZone === "STD" && promoRoamingZone === "BREXIT") {
    return "BREXIT";
  }

  if (
    (roamingZone === "STD" || roamingZone === "EXO") &&
    promoRoamingZone === "HT"
  ) {
    return "HT";
  }

  if (roamingZone === "STD") {
    return "STANDARD";
  }

  if (roamingZone === "EU") {
    return "EU";
  }

  if (roamingZone === "EXO") {
    return "EXOTIC";
  }

  return;
}
